/** play an audio file at a URL */
export function playAudio(url: string) {
  if (url !== '') {
    const audio = new Audio(url);
    audio.addEventListener("canplaythrough", _ => audio.play());
  }
}
